<template>
	<div>
		<div v-if="context.pwaLogo" class="w-[10rem] sm:w-[13rem] mx-auto my-6">
			<img :src="context.pwaLogo.src" :alt="context.pwaLogo.alt" />
		</div>
		<nk-container>
			<div
				v-if="context.pwaContactLinks"
				class="flex justify-evenly flex-wrap my-4"
			>
				<nk-link
					v-for="(pwaContact, pwaContactIndex) in context.pwaContactLinks"
					:key="pwaContactIndex"
					class="bg-primary-500 flex justify-center items-center text-white p-3 rounded-full no-underline hover:bg-primary-100 transition-all duration-300"
					:link="pwaContact.url"
				>
					<nk-icon :icon="pwaContact.icon" />
				</nk-link>
			</div>
		</nk-container>
		<div v-if="context.pwaImage" class="relative -z-10 -mb-4">
			<nk-image
				:src="context.pwaImage.src"
				:alt="context.pwaImage.alt"
				ar="16:9"
				class="rounded-t-lg overflow-hidden"
			/>
		</div>
		<div v-if="context.pwaCards" class="w-full bg-primary-500 py-4">
			<nk-container>
				<div class="grid md:grid-cols-3 grid-cols-2 gap-4">
					<nk-link
						v-for="(PwaCard, PwaCardIndex) in context.pwaCards"
						:key="PwaCardIndex"
						class="bg-white p-3 flex flex-col justify-between rounded-lg no-underline transition-all duration-300"
						:link="PwaCard.url"
					>
						<div
							class="bg-primary-100 p-2 w-8 h-8 flex justify-center items-center rounded-lg text-primary-600"
						>
							<nk-icon :icon="PwaCard.icon" />
						</div>
						<p class="text-primary-600 mt-3 font-medium">
							{{ PwaCard.title }}
						</p>
					</nk-link>
				</div>
			</nk-container>
		</div>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplatePwaUebersicht',
	mixins: [TemplatesDefault],
};
</script>
q
